import 'react-table/react-table.css'

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { I18n } from 'react-redux-i18n';

import TableControl from 'controls/table/Table';
import ContentLoader from 'controls/content-loader/ContentLoader';

import request from 'actions/request';
import transmit from 'actions/transmit';

const TOP_CONTROLS_HEIGHT = 105;

class Table extends Component {
  constructor(props) {
    super(props);

    this.columns = [{
      Header: I18n.t('tracksTable.table.vehicle'),
      accessor: 'vehicle'
    }, {
      Header: I18n.t('tracksTable.table.name'),
      accessor: 'name',
    }, {
      Header: I18n.t('tracksTable.table.organization'),
      accessor: 'organization',
    }, {
      Header: I18n.t('tracksTable.table.startedAt'),
      accessor: 'startedAtFormatted'
    }, {
      Header: I18n.t('tracksTable.table.origin'),
      accessor: 'origin'
    }, {
      Header: I18n.t('tracksTable.table.destination'),
      accessor: 'destination'
    }];
  }

  componentDidMount() {
    this.resize();

    if (this.props.isAuthenticated && this.props.tracks.pending !== false) {
      this.fetchTracks();
    }
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.isAuthenticated && this.props.isAuthenticated) {
      this.fetchTracks();
    }

    this.resize();
  }

  fetchTracks() {
    this.props.request(
      ['tracks', 'getAll'],
      'get',
      'TRACKS'
    );
  }

  resize() {
    this.container.style.height = window.innerHeight - TOP_CONTROLS_HEIGHT + 'px';
  }

  handleGetTrProps(state, rowInfo, column, instance) {
    return {
      className: (() => {
        if (!rowInfo || !this.props.tracks.chosenItems) {
          return '';
        }

        let isChosen = this.props.tracks.chosenItems.some((element) => {
          return element.id === rowInfo.original.id
        });

        return isChosen ? 'is-chosen' : '';
      })(),
      onClick: event => {
        let target = event.currentTarget;
        target.classList.toggle('is-chosen');

        this.props.transmit(
          'TRACKS_CHOISE_TOGGLE',
          {
            id: rowInfo.original.id,
            checkstate: target.classList.contains('is-chosen')
          }
        );
      }
    }
  }

  buildTable() {
    //copying array
    var data = this.props.tracks.items.slice();

    return (<TableControl
      data={ data }
      columns={ this.columns }
      getTrProps={ this.handleGetTrProps.bind(this) }
    />);
  }

  buildBody() {
    if (this.props.tracks.pending !== false) {
      return <ContentLoader/>
    } else {
      return this.buildTable();
    }
  }

  render() {
    return (
      <div className='tracks-table-table'
        ref={(container) => { this.container = container; }}
      >
        { this.buildBody() }
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    isAuthenticated: state.user.login !== null,
    tracks: state.tracks,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    request: bindActionCreators(request, dispatch),
    transmit: bindActionCreators(transmit, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Table);
